
$("body").on('click', '.asyncSort--dropdown .asyncSort--value', function(e) {
    // $(".asyncSort--dropdown .asyncSort--list").removeClass('show');
    $(this).parent().find('.asyncSort--list').toggleClass('show');
  });

  $("body").on('click', '.asyncSort--dropdown button.xigen--translate.collapsed', function(e) {
    // $(".asyncSort--dropdown .asyncSort--list").removeClass('show');
    $(this).parent().parent().parent().find('.asyncSort--list').addClass('show-mobile');
    $(this).parent().parent().parent().find('.asyncSort--list').toggleClass('show');
  });

  let filter_color = '',
    filter_size = '';

  $("body").on('click', '.asyncSort--dropdown .asyncSort--list li', function(e) {
    $(".asyncSort--dropdown .asyncSort--list").removeClass('show');
    $(".filter-by--container").addClass('show');
    let filter_type = '';
    if ($(this).hasClass('filterColour')) {
      filter_type = 'colour';
      filter_color = $(this).attr('data-colour');
    } else if ($(this).hasClass('filterSize')) {
      filter_type = 'size';
      filter_size = $(this).html().trim();
    }

    $(".filter-by--container .filter-by--option[data-type='" + filter_type + "']").addClass('show');
    $(".filter-by--container .filter-by--option[data-type='" + filter_type + "'] .filter-by--text").html($(this).html());

    filterProducts();
  });

  function filterProducts() {
    if (filter_color == '' && filter_size == '') {
      $(".filter-by--container").removeClass('show');
    }

    $("#DDcolours span").html(
      filter_color == ''
        ? 'ALL'
        : filter_color
    );
    $("#DDsize span").html(
      filter_size == ''
        ? 'ALL'
        : filter_size
    );

    $("#product-grid li.async--grid__element").each(function(i, item) {
      let colors = $(item).attr('colors');
      let sizes = $(item).attr('sizes');

      if (colors.indexOf(filter_color) !== -1 && sizes.indexOf(filter_size) !== -1) {
        $(item).css('display', 'flex').addClass('filter-showing-size');;
      } else {
        $(item).css('display', 'none').removeClass('filter-showing-size');
      }
    });
  }

  $("body").on('click', '.filter-by--container .filter-by--clear', function(e) {
    filter_color = '';
    filter_size = '';

    $(".filter-by--container").removeClass('show');
    $(".filter-by--container .filter-by--option").removeClass('show');

    filterProducts();
  });

  $("body").on('click', '.filter-by--option.filter-by--option__size svg', function(e) {
    filter_size = '';
    $(this).parents('.filter-by--option__size').removeClass('show');

    filterProducts();
  });

  $("body").on('click', '.filter-by--option.filter-by--option__colour svg', function(e) {
    filter_color = '';
    $(this).parents('.filter-by--option__colour').removeClass('show');

    filterProducts();
  });

  $("body").on('click', '.async--grid__chip-holder', function(e) {
    const child = $(this).parents('.async--grid__element');

    if (! child.hasClass('is-expanded')) {
      const parent = $(this).parents('.async--grid');
      $('.async--grid__element').removeClass('is-expanded');
      child.addClass('is-expanded');
      const childIndex = parent.children('.filter-showing-size').index(child);

      const n = ($(window).width() <= 768) ? childIndex % 3 : childIndex % 8;

      child.find('.async--grid__extra').css('left', 'calc((-100% * ' + n + ') - (' + n + ' * 8px))');
    } else {
      child.removeClass('is-expanded');
    }
  });

  // close the popup
  $("body").on('click', '.close_productExtra--content', function(e) {
    $(this).parents('.async--grid__element').removeClass('is-expanded');
  });